<template>
  <div
    :class="[
      `bg-${background}`,
      darkSurfaceBgClass(background),
      'rounded-lg p-4 lg:p-8',
      hoverBackground ? `hover:bg-${hoverBackground}` : '',
      hoverBackground ? darkSurfaceHoverBgClass(hoverBackground) : '',
    ]"
    class="transition-colors duration-200"
  >
    <slot name="header"></slot>

    <div>
      <p v-if="title" class="text-base font-semibold mb-2 dark:text-dark-ink">{{ title }}</p>
      <p v-if="description" class="text-base text-grey-11 dark:text-dark-ink-muted">{{ description }}</p>

      <slot name="body"></slot>
    </div>

    <slot name="footer"></slot>
  </div>
</template>

<script setup>
import { darkSurfaceBgClass, darkSurfaceHoverBgClass } from '../../../stores/themeStore.ts'

defineProps({
  title: {
    type: String,
    required: false,
    default: '',
  },
  hoverBackground: {
    type: String,
    default: '',
  },
  background: {
    type: String,
    default: 'grey-10',
  },
  description: {
    type: String,
    required: false,
    default: '',
  },
})
</script>
